<template>
  <div class="wrap" style="height:100%">
    <app-header v-if="showHeaderAndFoot"></app-header>
    <app-main></app-main>
    <app-footer
      v-if="showHeaderAndFoot"
      :class="{ 'show-footer-bar': isMomileJobDetails }"
    ></app-footer>
    <div
      v-if="this.$route.path != '/index'"
      class="sNav"
      style="position:fixed;top:calc(50% + 64px);display:block"
    >
      <el-backtop target=".wrap">
        <li class="backTop">
          <i class="icons-up"></i>
        </li>
      </el-backtop>
    </div>
  </div>
</template>
<script>
import { AppFooter, AppHeader, AppMain } from "./components";

export default {
  name: "Layout",
  components: {
    AppMain,
    AppHeader,
    AppFooter,
  },
  computed: {
    showHeaderAndFoot() {
      if (
        this.$router &&
        this.$router.currentRoute &&
        this.$router.currentRoute.fullPath &&
        this.$router.currentRoute.fullPath == "/login"
      ) {
        return false;
      } else {
        return true;
      }
    },
    isMomileJobDetails() {
      const path = this.$route.path;
      return path.includes('/jobDetails') && this.$IsMobile
    },
  },
};
</script>
<style lang="scss" scoped>
.show-footer-bar {
  margin-bottom: 53px;
}
</style>
